import { Lightning } from '@lightningjs/sdk'

import { transparent } from '../../constants/colors'
import { Flo } from '../../types/flo-auth-api'
import ProductItem, { PRODUCT_ITEM_MARGIN } from './productItem'
import { createProductItems, toProductItemRef } from './signUpUtils'

export default class ProductsList extends Lightning.Component {
  private _currentEl = 0

  static _template() {
    return {
      w: (w) => w,
      rect: true,
      color: transparent,
      Wrapper: {
        w: (w) => w,
        h: (h) => h,
        clipping: true,
        flex: {
          direction: 'column',
          alignItems: 'center',
        },
        Items: {
          flex: {
            direction: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          },
        },
      },
    }
  }

  get currentEl() {
    return this._currentEl
  }

  set currentEl(v: number) {
    this._currentEl = v
  }

  get items() {
    return this.tag('Items')
  }

  get totalEl() {
    return this.items.children.length
  }

  get currentChild() {
    return this.getChild(this._currentEl)
  }

  get firstChild() {
    return this.getChild(0)
  }

  get lastChild() {
    return this.getChild(this.totalEl - 1)
  }

  set products(productList: Flo.Offers.OffersList) {
    this.items.patch({ children: createProductItems(productList) })
    this._refocus()
  }

  getChild(index: number) {
    return this.items.childList.getByRef(toProductItemRef(index)) as ProductItem
  }

  _getFocused() {
    return this.currentChild
  }

  _handleUp() {
    if (this._currentEl > 0) {
      this._currentEl--
      if (this._currentEl < this.totalEl - 2) {
        this.items.patch({
          smooth: {
            y: -this._currentEl * (this.items.children[0].finalH + PRODUCT_ITEM_MARGIN),
          },
        })
      }
    }
  }

  _handleDown() {
    if (this._currentEl < this.totalEl - 1) {
      this._currentEl++
      if (this._currentEl < this.totalEl - 2) {
        this.items.patch({
          smooth: {
            y: -this._currentEl * (this.items.children[0].h + PRODUCT_ITEM_MARGIN),
          },
        })
      }
    }
  }

  _handleEnter() {
    this.fireAncestors('$onSelectProduct', this._currentEl)
  }
}
